module.exports = __webpack_public_path__ + "static/media/ico_ticket.d1384bca.svg";